<template>
  <div class="webPage">
    <template v-if="from!='introDetail'">
      <div id="block"></div>
      <Header />
      <Box1 />
    </template>
    <Box2 />
    <Box4 />
    <Box5 />
    <Box6 />
    <Box7 />
    <Box8 />
    <Box9 />
    <Box10 />
    <Box11 />
    <Box12 />
    <Box13 />
    <Box14 /> 
    <Box15 />
    <pageRightFloat pageName="HTML&JS+前端-就业课"/>
    <Footer />
    <RightBtnVideo :src="src" btnName="快速了解前端" btnstyle="3" pageName="HTML&JS+前端-就业课"></RightBtnVideo>
  </div>
</template>

<script>
import Box1 from "./Box1.vue";
import Box2 from "./Box2.vue";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
import Box6 from "./Box6.vue";
import Box7 from "./Box7.vue";
import Box8 from "./Box8.vue";
import Box9 from "./Box9.vue";
import Box10 from "./Box10.vue";
import Box11 from "./Box11.vue";
import Box12 from "./Box12.vue";
import Box13 from "./Box13.vue";
import Box14 from "./Box14.vue";
import Box15 from "./Box15.vue";
import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
import RightBtnVideo from "../common/videoRightBtn.vue";
export default {
  components: {
    Box1,
    Box2,
    Box4,
    Box5,
    Box6,
    Box7,
    Box8,
    Box9,
    Box10,
    Box11,
    Box12,
    Box13,
    Box14,
    Box15,
    pageRightFloat,
    Header,
    Footer,
    RightBtnVideo,
  },
  data() {
    return {
      from:'',
      src: "https://file.boxuegu.com/bxgyingxiao/qianduan.mp4",
    };
  },
  mounted() {
   this.from=this.getQueryString("from")
  },
  methods: {
    toLink() {
    this.mai("HTML&JS+前端-就业课","快速了解前端",0,null)
      window.open("https://m.boxuegu.com/");
    },
  },
};
</script>

<style lang="scss" scoped>
#block {
  width: 100%;
  height: 88px;
}
</style>
